<div class="container-fluid">
    <div class="row">

      <div class="card shadow-sm p-0">
        <div class="card-header">
          <h3 class="card-title">{{ itemTypeId ? 'Update Item Types' : 'Create Item Types' }} </h3>
        </div>
        <div class="card-body">
          <item-types-form
            [itemType]="itemType"
          />
        </div>
      </div>
    </div>
    
  </div>
  